import Vue from 'vue';
import Router from 'vue-router';
// import Info from './views/Info.vue';
// import Login from './views/Login.vue';
// import List from './views/List.vue';
// import Detail from './views/Detail.vue';
// import Add from './views/Add.vue';
// import Layout from './views/Layout.vue';
// import Home from './views/Home.vue';
// import Share from './views/Share.vue';
// import ResetPassword from './views/Reset-password.vue';

Vue.use(Router);

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  linkActiveClass: 'active',
  routes: [
    // {
    //   path: '/home',
    //   name: 'home',
    //   component: Home,
    //   children: [
    //     {
    //       path: 'list',
    //       name: 'list',
    //       component: () => import(/* webpackChunkName: "list" */ './views/List.vue'),
    //     },
    //     {
    //       path: 'user',
    //       name: 'user',
    //       component: () => import(/* webpackChunkName: "user" */ './views/User.vue'),
    //     },
    //   ],
    // },
    // {
    //   path: '/info',
    //   name: 'info',
    //   component: Info,
    // },
    {
      path: '/',
      name: 'login',
      // component: Login,
      // component: () => import(/* webpackChunkName: "login" */ './views/Login.vue'),
      component: (resolve) => {
        // eslint-disable-next-line import/no-dynamic-require
        require(['./views/Login.vue'], resolve);
      },
      meta: { title: 'map' },
    },
    {
      path: '/about',
      name: 'about',
      // component: Login,
      // component: () => import(/* webpackChunkName: "login" */ './views/Login.vue'),
      component: (resolve) => {
        // eslint-disable-next-line import/no-dynamic-require
        require(['./views/About.vue'], resolve);
      },
      meta: { title: 'map' },
    },
    {
      path: '/about/pc',
      name: 'about-pc',
      // component: Login,
      // component: () => import(/* webpackChunkName: "login" */ './views/Login.vue'),
      component: (resolve) => {
        // eslint-disable-next-line import/no-dynamic-require
        require(['./views/About-pc.vue'], resolve);
      },
      meta: { title: 'map' },
    },
    {
      path: '/share/:id',
      name: 'share',
      // component: Share,
      // component: () => import(/* webpackChunkName: "share" */ './views/Share.vue'),
      component: (resolve) => {
        // eslint-disable-next-line import/no-dynamic-require
        require(['./views/Share.vue'], resolve);
      },
    },
    {
      path: '/reset/password',
      name: 'reset-password',
      // component: ResetPassword,
      // eslint-disable-next-line max-len
      // component: () => import(/* webpackChunkName: "reset-password" */ './views/Reset-password.vue'),
      component: (resolve) => {
        // eslint-disable-next-line import/no-dynamic-require
        require(['./views/Reset-password.vue'], resolve);
      },
    },
    // {
    //   path: '/detail',
    //   name: 'detail',
    //   component: Detail,
    // },
    // {
    //   path: '/add',
    //   name: 'add',
    //   component: Add,
    // },
    {
      path: '/layout',
      name: 'layout',
      // component: () => import(/* webpackChunkName: "layout" */ './views/Layout.vue'),
      component: (resolve) => {
        // eslint-disable-next-line import/no-dynamic-require
        require(['./views/Layout.vue'], resolve);
      },
      children: [
        {
          path: 'book-card',
          name: 'book-card',
          // component: () => import(/* webpackChunkName: "book-card" */ './views/Book-card.vue'),
          // component: BookCard,
          component: (resolve) => {
            // eslint-disable-next-line import/no-dynamic-require
            require(['./views/Book-card.vue'], resolve);
          },
        },
        {
          path: 'week-report',
          name: 'week-report',
          // component: () => import(/* webpackChunkName: "book-card" */ './views/Week-report.vue'),
          component: (resolve) => {
            // eslint-disable-next-line import/no-dynamic-require
            require(['./views/Week-report.vue'], resolve);
          },
        },
        {
          path: 'class-overview',
          name: 'class-overview',
          // eslint-disable-next-line max-len
          // component: () => import(/* webpackChunkName: "class-overview" */ './views/Class-overview.vue'),
          component: (resolve) => {
            // eslint-disable-next-line import/no-dynamic-require
            require(['./views/Class-overview.vue'], resolve);
          },
        },
        {
          path: 'volunteer-manage',
          name: 'volunteer-manage',
          // eslint-disable-next-line max-len
          // component: () => import(/* webpackChunkName: "volunteer-manage" */ './views/Volunteer-manage.vue'),
          // component: BookCard,
          component: (resolve) => {
            // eslint-disable-next-line import/no-dynamic-require
            require(['./views/Volunteer-manage.vue'], resolve);
          },
        },
        {
          path: 'volunteer-detail',
          name: 'volunteer-detail',
          // eslint-disable-next-line max-len
          // component: () => import(/* webpackChunkName: "volunteer-detail" */ './views/Volunteer-detail.vue'),
          // component: BookCard,
          component: (resolve) => {
            // eslint-disable-next-line import/no-dynamic-require
            require(['./views/Volunteer-detail.vue'], resolve);
          },
        },
        {
          path: 'user-manage',
          name: 'user-manage',
          // eslint-disable-next-line max-len
          // component: () => import(/* webpackChunkName: "volunteer-manage" */ './views/Volunteer-manage.vue'),
          // component: BookCard,
          component: (resolve) => {
            // eslint-disable-next-line import/no-dynamic-require
            require(['./views/User-manage.vue'], resolve);
          },
        },
        {
          path: 'homework',
          name: 'homework',
          // eslint-disable-next-line max-len
          // component: () => import(/* webpackChunkName: "volunteer-manage" */ './views/Volunteer-manage.vue'),
          // component: BookCard,
          component: (resolve) => {
            // eslint-disable-next-line import/no-dynamic-require
            require(['./views/Homework.vue'], resolve);
          },
        },
        {
          path: 'reading-plan-manage',
          name: 'reading-plan-manage',
          // eslint-disable-next-line max-len
          // component: () => import(/* webpackChunkName: "volunteer-manage" */ './views/Volunteer-manage.vue'),
          // component: BookCard,
          component: (resolve) => {
            // eslint-disable-next-line import/no-dynamic-require
            require(['./views/Reading-plan-manage.vue'], resolve);
          },
        },
        {
          path: 'reading-plan-reader-manage',
          name: 'reading-plan-reader-manage',
          // eslint-disable-next-line max-len
          // component: () => import(/* webpackChunkName: "volunteer-manage" */ './views/Volunteer-manage.vue'),
          // component: BookCard,
          component: (resolve) => {
            // eslint-disable-next-line import/no-dynamic-require
            require(['./views/Reading-plan-reader-manage.vue'], resolve);
          },
        },
        {
          path: 'process',
          name: 'process',
          // eslint-disable-next-line max-len
          // component: () => import(/* webpackChunkName: "volunteer-detail" */ './views/Volunteer-detail.vue'),
          // component: BookCard,
          component: (resolve) => {
            // eslint-disable-next-line import/no-dynamic-require
            require(['./views/Process.vue'], resolve);
          },
        },
        // {
        //   path: 'pagination',
        //   name: 'pagination',
        //   component: () => import(/* webpackChunkName: "pagination" */ './views/Pagination.vue'),
        // },
        // {
        //   path: 'bookcase',
        //   name: 'bookcase',
        //   component: () => import(/* webpackChunkName: "bookcase" */ './views/Bookcase.vue'),
        // },
        // {
        //   path: 'image',
        //   name: 'image',
        //   component: () => import(/* webpackChunkName: "image" */ './views/Image.vue'),
        // },
      ],
    },
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    // },
  ],
});
